// eslint-disable-next-line import/prefer-default-export
export enum MESSAGE_TYPE {
    NEW_PROJECT = 'new-project',
    NEW_REPAIR = 'new-repair',
    PROJECT_COMPLETE = 'project-complete',
    PROJECT_GROUP = 'project-group',
    REPAIR = 'repair',
    REPAIR_COMPLETE = 'repair-complete',
}
